<template>
  <div :class="['content mb-5', { 'policy-no-subtitle': !pageMeta.subTitle }]">
    <b-row>
      <b-col>
        <h2 class="mb-3">{{ $t("All Device Exceptions") }}</h2>
        <t-data-table
          data-test-id="device-exceptions-data-table"
          with-filter
          hoverable
          :filter-placeholder="$t('Search Device Exceptions')"
          :loading="loading"
          :table-data="tableData"
          :actions="tableActions"
          @on-delete="onDelete"
          @on-add="onAdd"
          @on-export="onExport"
          @on-row-clicked="onRowClicked"
          @on-inline-edit="onInlineEdit"
          :searchExports="searchExports"
          :columnsOnLoad="7"
          @export-headers="exportedHeaders"
          :displayDeleteWarningWhen="['default', 'devices']"
          :deleteWarningString="
            $t(
              'This Device Exception(s) is currently in use on a Device(s) or in Device Configuration. If you Delete this Device Exception(s) it will be removed from the Devices/Device Configuration'
            )
          "
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
"name": "Device Exceptions",
"meta": {
"authorize" : [1, 3, 4]
}
}
</route>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  layout: "customer",
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("deviceExceptions", [
      "fetchDeviceExceptions",
      "deleteDeviceExceptions",
    ]),
    ...mapMutations("modal", ["createModal", "showModal"]),
    onAdd() {
      this.createModal({
        modal: "t-add-device-exceptions",
        dataTestId: "modal-add-device-exceptions",
        title: this.$t("Add Device Exception"),
        modalData: {},
        props: {
          size: "lg",
          okTitle: this.$t("Add"),
        },
      });
      this.showModal();
    },
    async onDelete(exceptions) {
      try {
        await this.deleteDeviceExceptions({
          exceptions,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Deleted X X", {
            count: exceptions.length,
            item: this.$t("Device Exception(s)"),
          }),
          duration: 2000,
          variant: "success",
        });
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }
    },
    onRowClicked(item) {
      this.$router.push({
        path: `/customer/settings/device_exceptions/device_exception_rules`,
        query: {
          exceptionName: item.name,
          exceptionId: item.id,
          exceptionIsDefault: item.default,
          exceptionDevicesCount: item.devices,
        },
      });
    },
    onInlineEdit(item) {
      this.createModal({
        modal: "t-inline-edit-device-exception",
        dataTestId: "modal-inline-edit-device-exception",
        title: this.$t("Update Device Exception"),
        modalData: {
          item: item,
        },
        props: {
          size: "lg",
          okTitle: this.$t("Save"),
        },
      });
      this.showModal();
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "Device Exceptions");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No Device Exceptions in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
  },

  data: function () {
    return {
      loading: true,
      currentHeaders: null,
      tableActions: {
        add: {
          enabled: true,
          actions: [
            {
              text: this.$t("Add Device Exception"),
            },
          ],
        },
        export: { enabled: true },
        import: { enabled: false },
        delete: { enabled: true },
      },
      searchExports: ["name", "status", "user", "key"],
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("deviceExceptions", ["deviceExceptions"]),
    ...mapGetters("pageMeta", ["pageMeta"]),

    tableData: {
      get() {
        return this.$store.state.deviceExceptions.deviceExceptionsData;
      },
      set() {},
    },
  },

  async created() {
    await this.fetchDeviceExceptions({
      userId: this.selectedUser.id,
    });

    this.setPageTitle(this.$t("Device Exceptions"));
    this.setPageSubtitle([
      this.$t(
        "Use device exceptions to make an adjustment to a device, such as bypass OTG or use a specific DNS resolver. Create a device exception, add rules to it, and then apply it to one or many devices."
      ),
    ]);
    this.loading = false;
  },
};
</script>
